/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
/* eslint-disable jsx-a11y/anchor-is-valid  */
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default function (value) {
  const [t] = useTranslation();
  const options = useMemo(
    () => [
      { label: '', value: '', key: '' },
      { label: t('common.male'), value: 'Male', key: 'male' },
      { label: t('common.female'), value: 'Female', key: 'female' },
      { label: t('common.diverse'), value: 'Unknown', key: 'unknown' },
      { label: t('common.no_information'), value: 'Null', key: 'null' },
    ],
    []
  );
  const valueOption = useMemo(() => [options.find(o => o.value === value)], [value]);

  return [options, valueOption];
}
